import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FirebaseUser, User } from 'app/types';
import { getUser } from 'app/services/firebase/functions';

interface AuthState {
  fetchUserLoading: boolean;
  isLogged: boolean;
  isAuthLoading: boolean;
  firebaseUser: FirebaseUser | null;
  user: User | null;
}

const initialState: AuthState = {
  fetchUserLoading: false,
  isLogged: false,
  isAuthLoading: true,
  firebaseUser: null,
  user: null,
};

export const fetchUser = createAsyncThunk('auth/user/fetch', () => {
  return getUser();
});

const authStateSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    updateUser: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = {
          ...state.user,
          ...action.payload,
        };
      }
    },
    logIn: (state, action: PayloadAction<FirebaseUser>) => {
      state.firebaseUser = action.payload;
      state.isLogged = true;
    },
    logOut: (state) => {
      state.firebaseUser = null;
      state.isLogged = false;
    },
    setIsAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.isAuthLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.fetchUserLoading = true;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.fetchUserLoading = false;
      })
      .addCase(fetchUser.rejected, (state) => {
        state.fetchUserLoading = false;
      });
  },
});

export const { setUser, updateUser, logIn, logOut, setIsAuthLoading } =
  authStateSlice.actions;

export default authStateSlice.reducer;
